import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'onboardingStatus',
  standalone: false,
})
export class OnboardingStatusPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: unknown): string {
    return (
      this.translate.instant(`enums.onboardingStatus.${value}`) ||
      this.translate.instant('common.unknown')
    );
  }
}
